<template>
  <div>
    <!------ plainform area start ------->
    <section class="plainform-area">
      <div class="container room-list">
        <price-one-app
          v-for="(item, index) in roomsList"
          :key="index"
          :data="item"
          :index="index"
          :hotels="hotels"
          :translations="translations"
          :showRateRoom="roomsList.length>1"
          @closed="removeItem"
          @update="updateItem"
          @setPriceLoading="getPriceLoading"
        />
        <div class="btn-group bnf-add-room-wrap">
          <button class="btn-primary bnf-add-room-btn"  @click="addRoom" :disable="priceLoading">
            <b-spinner small type="grow" v-if="priceLoading"></b-spinner>
            <p v-else><i class="fas fa-plus" aria-hidden="true"></i> הוסף חדר נוסף</p>
          </button>
        </div>
      </div>
    </section>
    <!------ plainform area stop ------->
    <!----- order area start ----->

    <section class="order-area" v-if="device === 'desktop'">
      <div class="container">
        <div class="order-list d-flex">
          <ul>
            <li>
              {{ $t('product-page.average-per-passenger') }}
              <strong>{{ getPriceWithSymbol( product.cc, averagePrice) }}</strong>
            </li>
            <li>
              {{ $t('product-page.total-pay') }}
              <strong>{{ getPriceWithSymbol( product.cc, totalPrice) }}</strong>
            </li>
          </ul>
          <button class="btn-primary order" :disabled="disableBook" @click="gotoBook">הזמן עכשיו</button>
        </div>
        
      </div>
    </section>
    <section class="order-area bnf-order-area" v-else>
      <div class="container">
        <div class="order-list bnf-order-list">
          <ul>
            <li class="bnf-price-row bnf-price-secondary">
              <span class="bnf-price-label">{{ $t('product-page.average-per-passenger') }}</span>
              <strong class="bnf-price-value">{{ getPriceWithSymbol( product.cc, averagePrice) }}</strong>
            </li>
            <li class="bnf-price-row bnf-price-primary">
              <span class="bnf-price-label">{{ $t('product-page.total-pay') }}</span>
              <strong class="bnf-price-value">{{ getPriceWithSymbol( product.cc, totalPrice) }}</strong>
            </li>
            <li class="bnf-price-breakdown" v-if="hasInfants">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
              {{ getPriceWithSymbol( product.cc, packageBaseTotal) }} (חבילה) + {{ getPriceWithSymbol( product.cc, totalInfantCost) }} ({{ totalInfants === 1 ? 'תינוק' : `${totalInfants} תינוקות` }})
            </li>
          </ul>
        </div>
        <div class="btn-box bnf-cta-wrap">
          <button class="btn-primary bnf-cta-primary" :disabled="disableBook" @click="gotoBook">
            <span class="bnf-cta-text">הזמן עכשיו</span>
            <i class="fas fa-arrow-left bnf-cta-arrow" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </section>
    <!----- order area stop ----->
  </div>
</template>
<script>
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { BSpinner } from 'bootstrap-vue';
import gMixin from '@/utils/mixins';
import googleAnalytics from '@/utils/googleAnalytics';

const { VUE_APP_CHANNEL_MOBILE_APP } = process.env;

export default {
  components: {
    PriceOneApp: () => import('@/components/hotelFlight/PriceOneApp'),
    BSpinner,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
    hotelName: {
      type: String,
      default: '',
    },
    destinationCityName: {
      type: String,
      default: '',
    },
    includesText: {
      type: String,
      default: '',
    },
  },
  mixins: [gMixin, googleAnalytics],
  data() {
    return {
      searchQuery: '',
      query: null,

      personString: '',

      roomsList: [],
      maxRoomCount: 5,
      addRoomDisable: false,
      priceLoading: false,

      roomBasisCode: null,
      adult: 0,
      child: 0,
      infant: 0,
      totalPrice: 0,
      averagePrice: 0,
      translations: [],

      disableBookDiscount: false,
      disableBook: true,
    };
  },
  computed: {
    ...mapGetters({
      lang: 'GET_LANGUAGE',
      device: 'GET_DEVICE',
      typeChannel: 'GET_TYPE_CHANNEL',
      flights: 'GET_FLIGHT_ID',
      isFcAgentMarketerMode: 'GET_FC_AGENT_MARKETER_MODE',
    }),
    packageType() {
      const result = (this.categoryCode === 'Organize_tour_packages')
        ? `${this.$t('product-page.organized-trip')} ( ${this.$t('product-page.organized-trip-price-items')})`
        : `${this.$t('product-page.includes-message')}${this.includesText}`;
      return result;
    },
    categoryCode() {
      return this.product?.category?.code ?? '';
    },
    daysString() {
      return this.getBetweenDateString(this.query.dateFrom, this.product.hotel_shift_1, this.product.duration_1, this.product.hotels[0].duration);
    },
    /* R5: total infant cost across all rooms — for the breakdown line */
    totalInfantCost() {
      return this.roomsList.reduce((sum, room) => {
        const inf = Number(room.infant || 0);
        const priceInf = Number(room.priceInf || 0);
        return sum + (inf * priceInf);
      }, 0);
    },
    totalInfants() {
      return this.roomsList.reduce((sum, room) => sum + Number(room.infant || 0), 0);
    },
    hasInfants() {
      return this.totalInfants > 0;
    },
    /* package-only price = total - infant cost */
    packageBaseTotal() {
      return Math.max(0, Number(this.totalPrice) - this.totalInfantCost);
    },
    disableBookingOnAPP() {
      return this.typeChannel === VUE_APP_CHANNEL_MOBILE_APP;
    },
  },
  watch: {
    roomsList() {
      this.paxesDisable = this.roomsList.length === this.maxRoomCount;
      this.updateTotalPrice();
    },
    lang() {
      this.personString = this.getPersonString(
        this.adult,
        this.child,
        this.infant,
      );
    },
  },
  beforeMount() {
    this.hotels = this.product.hotels;
    this.translations = this.product.translations;

    this.query = this.$route.query;
    const { adult, child, infant } = this.query;
    this.adult = Number(adult);
    this.child = Number(child);
    this.infant = Number(infant);

    this.personString = this.getPersonString(
      this.adult,
      this.child,
      this.infant,
    );
    this.roomsList.push(this.getOneItem());
  },
  methods: {
    getWeek(str) {
      const week = [
        this.$t('weekAllName.sun'),
        this.$t('weekAllName.mon'),
        this.$t('weekAllName.tue'),
        this.$t('weekAllName.wed'),
        this.$t('weekAllName.thu'),
        this.$t('weekAllName.fri'),
        this.$t('weekAllName.sat'),
      ];
      return week[dayjs(str).day()];
    },
    getBetweenDateString(pFromDate, pShift, pDuration, pNight) {
      const checkIn = dayjs(pFromDate).add(Number(pShift), 'day'),
        checkOut = checkIn.add(Number(pDuration), 'day');
      let tripDuration = '', betweenDateString = '';
      if (this.lang === 'he') {
        tripDuration = `${this.getWeek(checkIn)} ${dayjs(checkIn).format('DD/MM/YY')} - ${this.getWeek(checkOut)} ${dayjs(checkOut).format('DD/MM/YY')} (${pNight} ${this.$t('search-result.night')})`;
        betweenDateString = tripDuration;
      } else {
        tripDuration = `${this.getWeek(checkIn)} ${dayjs(checkIn).format('DD/MM/YY')} - 
            ${this.getWeek(checkOut)} ${dayjs(checkOut).format('DD/MM/YY')} (${pNight} ${this.$t('search-result.night')})`;
        betweenDateString = tripDuration;
      }
      return betweenDateString;
    },
    getPersonString(adult, child, infant) {
      let str = '';
      if (adult === 1) {
        str = `${adult} ${this.$t('product-page.adult')}`;
      } else {
        str = `${adult} ${this.$t('product-page.adults')}`;
      }
      if (child === 1) {
        str += ` + ${child} ${this.$t('product-page.child')}`;
      } else if (child > 1) {
        str += ` + ${child} ${this.$t('product-page.children')}`;
      }
      if (infant === 1) {
        str += ` + ${infant}  ${this.$t('product-page.infant')}`;
      } else if (infant > 1) {
        str += ` + ${infant}  ${this.$t('product-page.infants')}`;
      }
      return str;
    },
    removeItem(index) {
      this.roomsList.splice(index, 1);
    },
    async addRoom() {
      if (!this.addRoomDisable) {
        this.roomsList.push(this.getOneItem());
        this.updateRoomsState();
      }
    },
    updateRoomsState() {
      const paxes = {
        adult: 0, child: 0, infant: 0,
      };
      this.roomsList.forEach((room) => {
        paxes.adult += room.adult;
        paxes.child += room.child;
        paxes.infant += room.infant;
      });
      this.$emit('message', { kind: 'upgradeRooms', paxes });
    },
    async updateItem(priceInfo) {
      if (priceInfo.success) {
        // if (priceInfo.price !== 0) {
        const flagUpdateBasis = this.roomBasisCode ? priceInfo.roomBasis !== this.roomBasisCode.value : false;
        for (const key in this.roomsList[priceInfo.index]) {
          this.roomsList[priceInfo.index][key] = priceInfo[key];
        }
        if (flagUpdateBasis) {
          for (let i = 0; i < this.roomsList.length; i += 1) {
            this.roomsList[i].roomBasis = priceInfo.roomBasis;
          }
        }
        this.averagePrice = 0;
        for (let i = 0; i < this.roomsList.length; i += 1) {
          this.averagePrice += this.roomsList[i].price;
        }
        this.averagePrice = Math.round(this.averagePrice / this.roomsList.length);
        this.updateTotalPrice();
        this.roomBasisCode = priceInfo.roomBasisCode;
        this.updateRoomsState();
      } else {
        this.disableBookDiscount = true;
        this.$emit('message', priceInfo.message);
      }
    },
    getOneItem() {
      return {
        hotelId: '',
        packSelectionId: this.product.packSelectionId,
        roomClass: { text: '', value: '' },
        roomType: { text: '', value: '' },
        roomBasis: this.roomBasisCode ? this.roomBasisCode.value : '',
        roomBasisCode: this.roomBasisCode,
        price: 0,
        adult: 0,
        child: 0,
        infant: 0,
        totalPrice: 0,
        oldPrice: 0,
        oldTotal: 0,
        priceInf: 0,
        cc: this.product.cc,
      };
    },
    updateTotalPrice() {
      this.totalPrice = this.roomsList.reduce((a, b) => +a + +b.totalPrice, 0);
      this.product.priceTotal = this.totalPrice;
      window.sessionStorage.setItem('production', JSON.stringify(this.product));
      this.$store.dispatch('UPDATE_ROOM_LIST', { roomList: this.roomsList });
    },
    getPriceLoading(isLoading) {
      this.priceLoading = isLoading;
      this.disableBook = isLoading || this.disableBookDiscount;
    },
    async gotoBook() {
      const selectedRooms = [],
        gHotel = this.product.hotels[0];
      let discountedTotal = 0, undiscountedTotal = 0, totalPerson = 0;
      this.roomsList.forEach((room) => {
        const roomData = {
          hotelId: Number(room.hotelId),
          cityCode: gHotel.city,
          hotelSupplierCode: gHotel.Supplier,
          basisCode: room.roomBasis,
          rooms: {
            roomClassCode: room.roomClass.value,
            roomTypeCode: room.roomType.value,
            accomodation: 1,
            bBCots: Number(room.infant),
            paxIds: [],
          },
        };
        discountedTotal += room.totalPrice - room.infant * room.priceInf;
        undiscountedTotal += room.oldTotal - room.infant * room.priceInf;
        totalPerson += (room.adult + room.child + room.infant);

        selectedRooms.push(roomData);
      });

      this.product.hotel = selectedRooms;
      this.product.packageId = Number(this.roomsList[0].roomBasisCode.packId);
      this.product.duration = Number(this.product.duration_1);
      this.product.discountPercent = (discountedTotal !== undiscountedTotal) ? ((undiscountedTotal - discountedTotal) * 100) / undiscountedTotal : null;
      this.product.price = Number(this.product.priceTotal);
      this.product.priceNIS = 0;
      this.product.currency = this.product.cc;
      this.product.ensureCancellation = false;
      const data = {
        data: this.product,
        sendingStage: 'init',
      };
      const response = await this.$store.dispatch('SEND_BOOKING_DATA', data);

      if (this.availableEmitEventGA4ByDomain()) {
        const affiliation = 'BO NAUF';
        const currencyCode = this.convertCurrencyCode(this.product.cc);
        this.gtag('event', 'view_item', {
          currency: currencyCode,
          value: this.totalPrice,
          items: [
            {
              item_id: response.data.bookingTransactionId,
              item_name: `${this.hotelName} - ${this.destinationCityName}`,
              affiliation,
              coupon: '',
              discount: '',
              index: 0,
              item_brand: '',
              item_category: this.destinationCityName,
              item_category2: this.getCheckInOut(),
              item_category3: '',
              item_category4: '',
              item_category5: '',
              item_list_id: '',
              item_list_name: '',
              item_variant: '',
              location_id: '',
              price: this.totalPrice,
              quantity: 1,
            },
          ],

          // items: [
          //   {
          //     id: response.data.bookingTransactionId, // please assign number
          //     name: `${this.hotelName} - ${this.destinationCityName}`,
          //     list_name: '',
          //     brand: '',
          //     category: '',
          //     variant: '',
          //     list_position: 1,
          //     quantity: 1,
          //     price: this.totalPrice,
          //   },
          // ],
        });
      }

      if (response.success) {
        this.product.priceNIS = response.data.priceNis;
        window.sessionStorage.setItem('production', JSON.stringify(this.product));
        window.sessionStorage.setItem('BookingDataID', response.data.bookingTransactionId);
        window.sessionStorage.setItem('retryState', 'null');
        window.sessionStorage.setItem('cancellationInfo', JSON.stringify({
          cancellationAllowed: this.product.cancellationAllowed,
          cancelInsuranceFee: response.data.cancelInsuranceFee,
          cancelInsuranceFeeNis: response.data.cancelInsuranceFeeNis,
          totalPerson,
        }));
        const body = {
          packID: this.product.packageId,
          laID: this.query.laId,
          flights: this.flights,
          marketerId: this.query.marketerId,
          channel: this.typeChannel,
        };
        if (this.$route.query.utm_source) body.utm_source = this.$route.query.utm_source;
        if (this.isFcAgentMarketerMode) body['fc-agent-mode'] = '';

        let type = this.device === 'mobile' ? 'app' : 'app-desktop';
        this.$router.push({ path: `/booking/hotel-flight/${type}`, query: body });
      } else {
        window.sessionStorage.setItem('BookingDataID', '');
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .bonauf-desktop {
    .order-area {
        position: fixed;
        bottom: 0px;
        width: 100%;
        background: #fff;
        z-index: 9;

      .order-list {
        li {
          font-family: 'ploniregularaaa';
          font-size: 28px;
          color: #000;

          strong {
            display: block;
            font-family: 'FbCoherentiSansBold';
            font-size: 30px;
          }
        }
      }

      .order {
        height: 50px;
        width: 160px;
        margin: auto;
      }
    }
  }
</style>
<style scoped>
  button:disabled,
  [type='button']:disabled,
  [type='reset']:disabled,
  [type='submit']:disabled {
    cursor: default;
    opacity: 0.2;
  }
  .room-list {
    max-width: 800px;
    margin: auto;
  }
  .bonauf-desktop .room-list .plainform-area::before{
    height: 200px;
  }

  /* ===== Add-room button — secondary look (replaces orange/yellow gradient) ===== */
  .bnf-add-room-wrap {
    display: flex;
    justify-content: center;
    margin: 20px 0 24px;
    padding: 0 12px;
  }
  .bnf-add-room-btn.btn-primary {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 22px;
    background: #ffffff !important;
    color: #1c4e80 !important;
    background-image: none !important;
    border: 1.5px dashed #1c4e80 !important;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 600;
    min-height: 44px;
    box-shadow: none;
    transition: background 0.2s ease, color 0.2s ease, border-style 0.2s ease;
  }
  .bnf-add-room-btn.btn-primary:hover,
  .bnf-add-room-btn.btn-primary:focus {
    background: #eff6ff !important;
    border-style: solid !important;
    outline: none;
  }
  .bnf-add-room-btn.btn-primary p {
    margin: 0;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .bnf-add-room-btn.btn-primary i {
    font-size: 12px;
  }

  /* ===== Order area (mobile sticky-bottom totals + CTA) ===== */
  .bnf-order-area {
    background: #ffffff;
    border-top: 1px solid #e3e9f1;
    padding: 16px 12px;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.05);
  }
  .bnf-order-area .container {
    max-width: 720px;
    margin: 0 auto;
  }
  .bnf-order-list {
    display: block;
  }
  .bnf-order-list ul {
    list-style: none;
    margin: 0 0 14px;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 16px;
  }
  .bnf-price-row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    line-height: 1.2;
  }
  .bnf-price-row .bnf-price-label {
    font-size: 12px;
    color: #6c7a8c;
    font-weight: 500;
  }
  .bnf-price-row .bnf-price-value {
    font-weight: 700;
    color: #0e436b;
  }
  /* Secondary (avg per passenger) — smaller */
  .bnf-price-secondary .bnf-price-value {
    font-size: 16px;
    color: #475569;
  }
  /* Primary (total to pay) — bigger, bolder, brand color */
  .bnf-price-primary {
    align-items: flex-end;
  }
  .bnf-price-primary .bnf-price-value {
    font-size: 22px;
    color: #0e436b;
  }
  /* Breakdown line — small chip under primary total when there are infants */
  .bnf-price-breakdown {
    list-style: none;
    margin: 6px 0 0 !important;
    padding: 4px 12px !important;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #eef6ff;
    border: 1px solid #cfe2ff;
    border-radius: 999px;
    font-size: 11.5px;
    font-weight: 500;
    color: #1c4e80;
    width: fit-content;
    align-self: flex-end;
    line-height: 1.3;
  }
  .bnf-price-breakdown i {
    font-size: 11px;
    color: #1c7ed6;
  }

  /* ===== Primary CTA (הזמן עכשיו) — refined, brand-colored, not orange-yellow ===== */
  .bnf-cta-wrap {
    width: 100%;
  }
  .bnf-cta-primary.btn-primary {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    padding: 14px 22px;
    background: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%) !important;
    background-image: linear-gradient(135deg, #0061ab 0%, #1c7ed6 100%) !important;
    color: #ffffff !important;
    border: none !important;
    border-radius: 12px;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0.3px;
    min-height: 52px;
    box-shadow: 0 4px 14px rgba(0, 97, 171, 0.32);
    transition: transform 0.12s ease, box-shadow 0.18s ease, filter 0.18s ease;
    cursor: pointer;
  }
  .bnf-cta-primary.btn-primary:hover:not(:disabled),
  .bnf-cta-primary.btn-primary:focus:not(:disabled) {
    box-shadow: 0 6px 18px rgba(0, 97, 171, 0.4);
    filter: brightness(1.05);
    outline: none;
  }
  .bnf-cta-primary.btn-primary:active:not(:disabled) {
    transform: translateY(1px);
    box-shadow: 0 2px 8px rgba(0, 97, 171, 0.28);
  }
  .bnf-cta-primary.btn-primary:disabled {
    background: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%) !important;
    background-image: linear-gradient(135deg, #94a8c5 0%, #b6c6dd 100%) !important;
    cursor: not-allowed;
    box-shadow: none;
    opacity: 1;
  }
  .bnf-cta-primary .bnf-cta-arrow {
    font-size: 14px;
    transition: transform 0.2s ease;
  }
  .bnf-cta-primary.btn-primary:hover .bnf-cta-arrow {
    transform: translateX(-3px);
  }

  @media (max-width: 479px) {
    .bnf-order-area {
      padding: 12px 10px;
    }
    .bnf-order-list ul {
      gap: 8px;
      margin-bottom: 12px;
    }
    .bnf-price-secondary .bnf-price-value {
      font-size: 15px;
    }
    .bnf-price-primary .bnf-price-value {
      font-size: 20px;
    }
    .bnf-cta-primary.btn-primary {
      font-size: 16px;
      min-height: 48px;
      padding: 12px 18px;
    }
  }
</style>
<style>
button.js-del-row {
  top: 5px;
}

@media (max-width: 600px) {
  div[id^='upgrade-'] .modal-dialog {
    width: 96%;
  }
  div[id^='upgrade-'] table th,
  div[id^='upgrade-'] table td {
    padding: 2px;
  }
}

@media (max-width: 768px) {
  .flightpagelist.filterItem {
    margin-top: 1em;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
    padding: 5px;
  }
}
</style>
